import { AchievementDefinition, Profile, LevelProgress } from '../types';

export const ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: 'first_star',
    name: 'First Star',
    description: 'Earn your first star',
    icon: '⭐',
    condition: (profile: Profile) => (profile.totalStars ?? 0) >= 1
  },
  {
    id: 'perfect_level',
    name: 'Perfect!',
    description: 'Complete a level with 100% accuracy',
    icon: '💯',
    condition: (progress: LevelProgress) => progress.accuracy === 100
  },
  {
    id: 'streak_master',
    name: 'Streak Master',
    description: 'Get a streak of 10 or more',
    icon: '🔥',
    condition: (profile: Profile) => (profile.bestStreak ?? 0) >= 10
  },
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    description: 'Complete a level in under 60 seconds',
    icon: '⚡',
    condition: (progress: LevelProgress) => progress.time < 60
  },
  {
    id: 'halfway_there',
    name: 'Halfway There',
    description: 'Complete 5 levels',
    icon: '🌟',
    condition: (profile: Profile) => (profile.levelsCompleted ?? 0) >= 5
  },
  {
    id: 'multiplication_master',
    name: 'Multiplication Master',
    description: 'Complete all 10 levels',
    icon: '🏆',
    condition: (profile: Profile) => (profile.levelsCompleted ?? 0) === 10
  },
  {
    id: 'star_collector',
    name: 'Star Collector',
    description: 'Collect 30 stars total',
    icon: '✨',
    condition: (profile: Profile) => (profile.totalStars ?? 0) >= 30
  },
  {
    id: 'high_scorer',
    name: 'High Scorer',
    description: 'Reach a total score of 5000',
    icon: '🎯',
    condition: (profile: Profile) => (profile.totalScore ?? 0) >= 5000
  }
];

export function checkAchievements(profile: Profile, progress?: LevelProgress): string[] {
  const newAchievements: string[] = [];
  
  ACHIEVEMENTS.forEach(achievement => {
    if (progress && achievement.id === 'perfect_level' || achievement.id === 'speed_demon') {
      if (achievement.condition(progress)) {
        newAchievements.push(achievement.id);
      }
    } else if (achievement.condition(profile)) {
      newAchievements.push(achievement.id);
    }
  });
  
  return newAchievements;
}